import React from 'react';
import { PostResponseSchema } from '@/api/client';
import PostCardLivestreamPostType from './PostCardLivestreamPostType';

interface Props {
  post: PostResponseSchema;
  onVideoClick?: (post: PostResponseSchema) => void;
  wrapperStyle?: React.CSSProperties;
}

export default function PostCardLivestream(props: Props): React.ReactElement {
  return <PostCardLivestreamPostType {...props} />;
}
